import React from "react";
import IconButton from "@mui/material/IconButton";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { printBudgetPdf } from "../../utils/printBudgetPdf";

const BudgetPrint = ({
  idPresupuesto,
  fechaPresupuesto,
  nombreProducto,
  precioUnitario,
  moneda,
  unidades,
  proveedorNombre,
  totalVenta,
}) => {
  const handlePrint = async () => {
    if (!idPresupuesto) return;
    try {
      await printBudgetPdf({
        idPresupuesto,
        fechaPresupuesto,
        nombreProducto,
        precioUnitario,
        moneda,
        unidades,
        proveedorNombre,
        totalVenta,
      });
    } catch (err) {
      console.error("Error al imprimir presupuesto:", err);
    }
  };

  return (
    <IconButton
      onClick={handlePrint}
      sx={{
        color: "#1976d2",
        width: "2.35rem",
        height: "2.35rem",
        flexShrink: 0,
        "&.MuiIconButton-root": { border: "1px solid #1976d2" },
        "&.MuiButtonBase-root": {
          padding: 0,
        },
        "& .MuiSvgIcon-root": { fontSize: "1.18rem" },
        "&:hover": { backgroundColor: "#1976d2", color: "#fff" },
      }}
    >
      <LocalPrintshopOutlinedIcon />
    </IconButton>
  );
};

export default BudgetPrint;
